import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { Base } from './Base'
import { Client } from './Client'

export enum UnitOfMeasure {
  cases = 'case',
  eaches = 'each',
  lbs = 'lbs',
}

export class SkuBase extends Base {
  static type = 'sku'
  static typeDisplay = 'SKU'
  static icon = Package

  type = SkuBase.type
  typeDisplay = SkuBase.typeDisplay
  icon = SkuBase.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  sku: string = ''

  @Expose({ name: 'track_date_received' })
  trackDateReceived?: boolean

  @Type(() => Client)
  client: Client = new Client()

  @Expose({ name: 'num_available' })
  numAvailable?: number

  @Expose({ name: 'num_reserved' })
  numReserved?: number

  @Expose({ name: 'num_awaiting_shipment' })
  numAwaitingShipment?: number

  @Expose({ name: 'num_damaged' })
  numDamaged?: number

  @Expose({ name: 'unit_of_measure' })
  unitOfMeasure: UnitOfMeasure = UnitOfMeasure.eaches

  static unitOfMeasureMap = {
    [UnitOfMeasure.cases]: 'case(s)',
    [UnitOfMeasure.eaches]: 'each(es)',
    [UnitOfMeasure.lbs]: 'lb(s)',
  }

  get unitOfMeasureDisplay () {
    return SkuBase.unitOfMeasureMap[this.unitOfMeasure]
  }

  @Expose({ name: 'storage_health' })
  storageHealth: number = 0

  @Expose({ name: 'is_active' })
  isActive?: boolean

  @Expose({ name: 'product_name' })
  productNameOverride?: string
}
